import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import { translate } from '~/core/translate'
import { CONTACT_LINK, MAX_MOBILE_THRESHOLD } from '~/core/constants'
import Button from '~/components/common/button'
import { buttonMediumCss, buttonLargeSemiboldCss } from '../typography'

const UpgradeButton = styled(Button).attrs(props => ({
  primary: Boolean(props.isActive),
  secondary: !props.isActive
}))`
  ${buttonLargeSemiboldCss}
  font-family: Inter;
  flex-shrink: 0;
  height: 48px;
  width: 100%;

  @media screen and (min-width: ${MAX_MOBILE_THRESHOLD}) {
    ${buttonMediumCss};
    height: 40px;
  }
`

const PlanButton = ({ children, isActive, selectPlan, id, shouldContactSales, name }) => {
  let text
  let onClick

  if (shouldContactSales) {
    text = translate('contact_sales')
    onClick = () => {
      window.open(CONTACT_LINK, '_blank', 'noopener')
    }
  } else {
    text = translate('select_package')
    onClick = () => {
      selectPlan(id)
    }
  }

  return (
    <UpgradeButton
      onClick={onClick}
      isActive={isActive}
      data-test-id={`${name} button`}
      theme={{
        backgroundColorPrimary: '#1B67EC',
        backgroundColorPrimaryActive: '#1B67EC',
        backgroundColorPrimaryHover: '#3D82FB',
        borderColorSecondary: '#1B67EC',
        fontColorSecondary: '#1B67EC'
      }}
    >
      {children || text}
    </UpgradeButton>
  )
}

PlanButton.propTypes = {
  isActive: PropTypes.bool,
  selectPlan: PropTypes.func,
  id: PropTypes.string,
  shouldContactSales: PropTypes.bool,
  name: PropTypes.string
}

export default PlanButton
